import styles from "./reports.module.scss";

const NoAccess = () => (
  <div className={styles.no_access_container}>
    <div>You don't have access to any of the reports.</div>
  </div>
);

export default NoAccess;
